module.exports = __webpack_public_path__ + "img/icon-msds-noimg.7af75465.svg";